module.exports = __webpack_public_path__ + "img/modern_blue.c9aeeb59.png";